import { Divider, Skeleton } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import TroubleshootRoundedIcon from "@mui/icons-material/TroubleshootRounded";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";

const CardCounter = ({
  counter: { Tot, Validated, NotValidated, Reject },
  isLoading,
}) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  if (isLoading) {
    return (
      <div
        className="shadow-md h-48 rounded-xl p-4 flex flex-col justify-between"
        style={{ minWidth: "15rem", maxWidth: "30rem" }}
      >
        <div>
          <Skeleton variant="text" height={45} />
          <Divider />
        </div>

        <div className="flex justify-around items-center space-x-4">
          {[1, 2, 3].map((index) => (
            <div
              className="flex justify-center items-center space-x-2"
              key={index}
            >
              <Skeleton variant="circular" width={40} height={40} />
              <Skeleton variant="text" width={50} height={45} />
            </div>
          ))}
        </div>
        <div></div>
      </div>
    );
  }

  return (
    <div
      className="shadow-md h-48 rounded-xl p-2 "
      style={{ minWidth: "15rem", maxWidth: "30rem" }}
    >
      <p className="text-2xl font-bold m-4">
        Documenti Totale: <span style={{ color: colorPrimary }}>{Tot}</span>
      </p>
      <Divider />
      <div className="flex justify-around items-center space-x-4 pt-2">
        <div className="flex justify-center items-center space-x-4 ">
          <CheckCircleOutlineRoundedIcon
            className="w-12  h-12 "
            style={{ color: "#359F1C" }}
          />
          <p className="text-3xl font-bold ">{Validated}</p>
        </div>
        <div className="flex justify-center items-center space-x-4">
          <TroubleshootRoundedIcon
            className="w-12  h-12 "
            style={{ color: "#D86F07" }}
          />
          <p className="text-3xl font-bold ">{NotValidated}</p>
        </div>
        <div className="flex justify-center items-center space-x-4">
          <HighlightOffRoundedIcon
            className="w-12  h-12 "
            style={{ color: "#C1272D" }}
          />
          <p className="text-3xl font-bold ">{Reject}</p>
        </div>
      </div>
    </div>
  );
};

export default CardCounter;
